export default {
    l_User_name: "Қолданушы аты",
    l_Phone: "Телефон",
    l_User_password: "Қолданушы құпия сөзі",
    l_Forgot_password: "Құпия сөзді қалпына келтіру",
    l_Login: "Кіру",
    l_Sign_out: "Шығу",
    l_EmailorPasswordisWrong: "Электрондық пошта немесе құпия сөз қате",
    l_User: "Қолданушы",
    l_Payments: "Төлемдер",
    l_Promocodes: "Промокоды",
    l_Messages: "Хабарламалар",
    l_Consolidations: "Біріктірулер",
    l_Courier_Orders: "Курьердегі тапсырыстар",
    l_Almaty: "Алматы",
    l_Name: "Аты",
    l_Add: "Қосу",
    l_Action: "Әрекет",
    l_Temu_return_back: "Temu складына қайтару",
    l_Return_excel: "Қайтару M-Batch(Excel)",
    l_Update: "Жаңарту",
    l_Edit: "Өңдеу",
    l_Submit: "Жіберу",
    l_Cancel: "Бас тарту",
    l_Are_you_sure_delete_this_task: "Бұл тапсырманы жойғыңыз келе ме?",
    l_Yes: "Иә",
    l_No: "Жоқ",
    l_Last_trackcodes: "Соңғы тректер",
    l_Tracking_number: "Бақылау нөмірі",
    l_Internal_Tracking_number: "Ішкі бақылау нөмірі",
    l_Medium_batch_count: "Meduim batch саны",
    l_Actual_Price: "Нақты баға",
    l_Estimated_price: "Болжалды баға",
    l_Actual_weight: "Нақты салмақ",
    l_kg: "кг",
    l_Estimated_weight: "Есептік салмақ",
    l_Delivery_country: "Жеткізу елі",
    l_Delivery_type: "Жеткізу түрі",
    l_Address: "Мекенжай",
    l_Execution_status: "Орындалу статусы",
    l_Cargo: "Тауар",
    l_Sign_up: "Тіркелу",
    l_Next: "Келесі",
    l_Verify_code: "Кодты тексеру",
    l_Set_password: "Құпия сөзді орнату",
    l_Confirm_password: "Құпия сөзді растау",
    l_Get_SMS: "SMS алу",
    l_Get_the_verification_code_first: "Алдымен растау кодын алыңыз",
    l_Confirm_password_error: "Құпия сөзді растау қатесі",
    l_Phone_number: "Телефон нөмірі",
    l_Password: "Пароль",
    l_Wrong_password_format: "Құпия сөз форматы қате",
    l_Please_enter_phone_number: "Телефон нөмірді енгізіңіз",
    l_Please_enter_sms: "SMS енгізіңіз",
    l_My_addresses: "Мекенжайларым",
    l_Accepted_time: "Қабылдаған уақыт",
    l_My_parcels: "Cәлемдемелерім",
    l_Total_weight: "Толық салмағы",
    l_Remark_time: "Белгіленген күн",
    l_Remark_JPID: "Белгілеген JPID",
    l_Buy_instead_of_me: "Сіз үшін сатып аламыз",
    l_Accepted_JPID: "Қабылдаған JPID",
    l_Accepted_stationCode: "Қабылдаған бөлімше",
    l_Remark_stationCode: "Белгілеген бөлімше",
    l_On_shelf: "Сөреде",
    l_Personal_data: "Жеке деректер",
    l_Update_password: "Құпия сөзді жаңарту",
    l_Old_Password: "Ескі құпия сөз",
    l_New_Password: "Жаңа құпия сөз",
    l_Successed: "Сәтті",
    l_Personal_information: "Жеке ақпарат",
    l_User_list: "Қолданушылар тізімі",
    l_Email: "Электрондық пошта",
    l_Add_user: "Қолданушыны қосу",
    l_Full_name: "Аты-жөні",
    l_IIN: "ЖСН",
    l_ID_number: "Жеке куәлік нөмірі",
    l_Issuing_authority: "Берген орган",
    l_Issue_date: "Берілген күні",
    l_Validity: "Қолданылу мерзімі",
    l_Delivery_address: "Жеткізу мекенжайы",
    l_Town: "Облыс-Қала/Аудан",
    l_Street: "Көше",
    l_House: "Үй",
    l_Postcode: "Пошта индексі",
    l_Identity_card: "Жеке куәлік",
    l_Facial: "Беттік жағы",
    l_Negotiable: "Артқы жағы",
    l_Draw_a_signature: "Қолтаңбаны салу",
    l_Or_download_the_signed_contract: "Немесе қол қойылған келісімшартты жүктеп қосыңыз",
    l_Note: "Ескертпелер",
    l_Precautions_for_uploading_pictures: "Қосылған құжаттың сапасы жақсы болуы керек. Сурет 1 МБ-тан аспауы керек.",
    l_Click_or_drag_ile_to_this_area_to_upload: "Файлды жүктеп қосу үшін осы аймаққа басыңыз немесе файлды әкеліп қойыңыз",
    l_My_order: "Тапсырысым",
    l_Track_code: "Трек-код",
    l_Recipient: "Алушы",
    l_Cargo_name: "Жүк атауы",
    l_Declared_price: "Жарияланған баға",
    l_Date: "Күн",
    l_Delivery_cost: "Жеткізу құны",
    l_Dispatch_country: "Жіберу елі",
    l_Delivery_method: "Жеткізу әдісі",
    l_Order: "Тапсырыс",
    l_Recipient_data: "Алушының деректері",
    l_Shipping_country: "Жеткізу елі",
    l_Transportation_method: "Тасымалдау әдісі",
    l_Price: "Баға",
    l_Quantity: "Саны",
    l_Total_cost: "Жалпы құн",
    l_Category: "Категория",
    l_Weapons_and_explosive_materials: "Қару және жарылғыш материалдар",
    l_Alcoholic_drinks: "Алкогольдік сусындар",
    l_Sprays_and_aerosols: "Спреи және аэрозольдер",
    l_Medicines_without_a_doctors_prescription: "Дәрігердің рецептісіз дәрі-дәрмектер",
    l_radioactive_elements: "Радиоактивті элементтер",
    l_Animals_and_plants: "Жануарлар мен өсімдіктер",
    l_ALL_RIGHTS_RESERVED: "БАРЛЫҚ ҚҰҚЫҚТАР САҚТАЛҒАН",
    l_Contact: "Контакт",
    l_About_us: "Біз туралы",
    l_The_shops: "Дүкендер",
    l_How_it_works: "Бұл қалай жұмыс істейді?",
    l_Rates: "Тарифтер",
    l_Frequently_asked_Questions: "Жиі қойылатын сұрақтар",
    l_Prohibited_Items: "Тыйым салынған заттар",
    l_Privacy_Policy: "Құпиялылық саясаты",
    l_Weight: "Салмақ",
    l_Declaration: "Декларация",
    l_Pay: "Төлеу",
    l_Provinces: "Аудандар",
    l_Country: "Мемлекет",
    l_Full_address: "Толық мекенжай",
    l_MY_ADDRESS_IN_CHINA_FOR_AUTO_DELIVERY: "КӨЛІКПЕН ЖЕТКІЗУ ҮШІН ҚЫТАЙДАҒЫ МЕКЕНЖАЙ",
    l_Add_product: "Тауар қосу",
    l_Please_enter_quantity: "Санын енгізіңіз",
    l_The_maximum_number_is: "Ең көп сан",
    l_China: "Қытай",
    l_Auto_delivery: "Автожеткізу",
    l_To_avoid_problems_during_customs_clearance_please_enter_a_detailed_description_of_the_product_name_in_Russian: "Кедендік тазалау кезінде мәселердің алдын алу үшін тауардың атауының орыс тілінде нақты сипаттамасын енгізуді сұраймыз.",
    l_Later_confirm: "Кейінірек растау",
    l_Confirm: "Растау",
    l_Succeed: "Операция сәтті өтті",
    l_Provide_a_link_to_the_product_we_will_buy_and_bring_it_for_you: "Тауардың сілтемесін жіберіңіз, біз оны сіз үшін сатып алып әкелеміз!",
    l_Cargo_link: "Тауар сілтемесі",
    l_Additional_comment: "Қосымша түсініктеме",
    l_Additional_price: "Қосымша баға",
    l_Are_you_willing_to_buy_if_the_price_fluctuates_up_to_7: "Егер баға 7% -ға дейін ауытқыса, сіз сатып алуға дайынсыз ба?",
    l_size: "Өлшем",
    l_Color: "Түс",
    l_Delivery_price: "Жеткізу бағасы",
    l_Promo_codes: "Промокодтар",
    l_Whether_the_payment_is_completed: "Төлем аяқталды ма?",
    l_Completed: "Аяқталды",
    l_Not_completed: "Аяқталмаған",
    l_Image_must_smaller_than_3MB: "Сурет 3 МБ-тан аз болуы керек!",
    l_Image_must_smaller_than_2MB: "Сурет 2 МБ-тан аз болуы керек!",
    l_Image_size_exceeds_5MB: "Сурет өлшемі максималды 5 МБ-тан асады",
    l_Image_must_be_500x500: "Сурет 500x500 болуы керек",
    l_Image_format_error: "Суреттің форматы қате!",
    l_Analytics: "Аналитика",
    l_Status: "Күйі",
    l_Order_id: "Тапсырыс идентификаторы",
    l_Traking_number: "Трэк код",
    l_Amount: "Сома",
    l_Payment_metehod: "Төлем әдісі",
    l_Payment: "Төлем",
    l_Recipients: "Алушылар",
    l_First_name: "Аты-жөні",
    l_Last_name: "Тегі",
    l_Type: "Типі",
    l_Client: "Клиент",
    l_Admin: "Админ",
    l_Last_login: "Соңғы кіру",
    l_Register: "Тіркелу",
    l_Verified: "Тексерілген",
    l_Not_verified: "Тексеруден өтпеді",
    l_All: "Барлығы",
    l_Search: "Іздеу",
    l_Statuses: "Күйлер",
    l_Start_country: "Шығатын ел",
    l_End_country: "Жететін ел",
    l_Sort: "Сұрыптау",
    l_Add_time: "Уақыт қосу",
    l_Update_time: "Уақытты өзгерту",
    l_Ascending: "Өсу ретімен",
    l_Descending: "Кему ретімен",
    l_Create_time: "Құрылған уақыт",
    l_Message: "Хабарлама",
    l_Send_message: "Хабарлама жіберу",
    l_Internal_tracking_number: "Ішкі бақылау нөмірі",
    l_Shopping_instead: "Орнына сатып алу",
    l_Size: "Өлшем",
    l_Description: "Сипаттамасы",
    l_Link: "Сілтеме",
    l_City: "Қала",
    l_All_cargo: "Барлық тауарлар",
    l_Volume: "Көлемі",
    l_Height: "Биіктік",
    l_Paid: "Төленген",
    l_Unpaid: "Төленбеген",
    l_Declaration_verify: "Декларацияны тексеру",
    l_Update_date: "Жаңарту күні",
    l_Add_date: "Күн қосу",
    l_Add_to_consolidation: "Біріктіруге қосу",
    l_Consolidation: "Біріктіру",
    l_Consolidation_id: "Біріктіру ID",
    l_Add_type: "Түрді қосу",
    l_Add_new: "Жаңа қосу",
    l_Contractor: "Мердігер",
    l_Selected_order_quantity: "Таңдалған тапсырыс саны",
    l_Flight_number: "Рейс нөмірі",
    l_Execution_date: "Орындау күні",
    l_Document: "Құжат",
    l_Add_order: "Тапсырысты қосу",
    l_Can_choose_to_consolidation: "Біріктіруді таңдай алады",
    l_төленген_сома: "Төленген сома",
    l_Payment_method: "Төлем әдісі",
    l_Card: "карта",
    l_Cash: "Қолма-қол ақша",
    l_External_ID: "Сыртқы идентификатор",
    l_Verification_succeeded: "Тексеру сәтті өтті",
    l_Verification_failed: "Тексеру сәтсіз аяқталды",
    l_Car_number: "Автокөлік нөмірі",
    l_trailer_car_number: "Тіркеме вагонының нөмірі",
    l_Foreign_warehouse: "Шетел қоймасы",
    l_Almaty_warehouse: "Алматы қоймасы",
    l_Info: "Ақпарат",
    l_Payment_amount: "Төлем сомасы",
    l_Automatic_storage_filter_cleared_when_refresh: "Автоматты сақтау сүзгісі жаңарту кезінде тазаланады",
    l_Not_found: "Табылмады",
    l_Contract_template: "Келісім-шарт үлгісі",
    l_File_format_error: "Файл пішімі дұрыс емес!",
    l_Back_home_page: "Өкінішке орай, сіз кірген бет табылмалы.",
    l_Picked_up: "Алып кетті",
    l_Not_picked_up: "Алған жоқ",
    l_Payment_status: "Төлем күйі",
    l_Ready_to_ship: "Жіберуге дайын",
    l_Belongs_category: "Тәуелді түрі",
    l_File: "Файл",
    l_Poster: "Постер",
    l_format_error: "Форматы қате",
    l_TN_CODE: "TNVED коды",
    l_Other: "Басқа",
    l_Company: "Компания",
    l_Order_tracking: "Тапсырысты қадағалау",
    l_Not_fount: "Табылмады",
    l_Submit_and_print_label: "Жіберу және label шығару",
    l_Are_you_sure_update_password: "Құпия сөзді шынымен жаңартасыз ба?",
    l_Print: "Басып шығару",
    l_Operator: "Оператор",
    l_Russian_language: "Орыс тілінде",
    l_Print_label: "Label шығару",
    l_Warehouse: "Қойма",
    l_Checking: "Тексерілуде",
    l_Verification_failed_description: "Тексеруден өтпеу себебі",
    l_Select: "Таңдау",
    l_Gross_weight: "Брутто салмағы",
    l_Join_warehouse: "Қоймаға қосу",
    l_Batch_number: "Топтама нөмірі",
    l_Unclaimed_order: "Иесіз тапсырыс",
    l_China_batch: "CN batch",
    l_Reject_order: "Тапсырысты қабылдамау",
    l_Mini_batch: "Mini batch",
    l_Kazakhstan_batch: "KZ batch",
    l_Branch_warehouse: "Бөлімше",
    l_Driver: "Жүргізуші",
    l_Dest_station: "Межелі станция",
    l_Batch: "Batch",
    l_Shelf: "Сөре",
    l_Add_to_shelf: "Сөреге қосу",
    l_Data: "Деректер",
    l_Settings: "Параметрлер",
    l_Creator: "Құрушы",
    l_Shelf_number: "Сөре нөмірі",
    l_Sorting_center: "Сұрыптау орталығы",
    l_Pick_up: "Алып кету",
    l_Scan: "Сканерлеу",
    l_Last_six_digits_of_mobile_number: "Телефон нөміріңіздің соңғы алты саны",
    l_Branch_batch: "Branch batch",
    l_Arrived_to_branch: "Филиалға жетті",
    l_Arrived: "Жетті",
    l_App_version: "Қолданба нұсқасы",
    l_App_version_title: "Нұсқа атауы",
    l_App_version_content: "Нұсқа мазмұны",
    l_App_version_system: "Қолданба жүйесі",
    l_Version: "Нұсқа нөмірі",
    l_Force_update: "Мәжбүрлеп жаңарту керек пе?",
    l_Published: "Жарияланған",
    l_Unpublished: "Жарияланбаған",
    l_Export_excel: "Excel шығару",
    l_Work_time: "Жұмыс уақыты",
    l_Manager: "Басқарушы",
    l_Province: "Облыс",
    l_Remark: "Ескертпе",
    l_Start: "Басталуы",
    l_End: "Аяқталуы",
    l_Do_not_add_randomly: "Кездейсоқ қосуға болмайды!",
    l_Find_branch: "Филиал анықтау",
    l_Refresh: "Жаңарту",
    l_Has_photo: "Суреті бар",
    l_Valid_time: "Жарамды уақыты",
    l_Visible_state: "Көріну күйі",
    l_File_update_time: "Файлды жаңарту уақыты",
    l_Time: "Уақыт",
    l_Created: "Құрылды",
    l_Group_payment: "Топтық төлем",
    l_Permission: "Рұқсат",
    l_System: "Жүйе",
    l_Info_api: "API ақпараты",
    l_Road_type: "Жол түрі",
    l_Official: "Ресми",
    l_Commerce: "Коммерция",
    l_Recommended_shelf: "Ұсынылған сөре",
    l_Amount_payable_by_the_client: "Клиент төлеуге тиісті сома",
    l_Payment_completed: "Төлем орындалды",
    l_Error_batch: "Қайтару batch",
    l_Error_order: "Қайтару тапсырыс",
    l_Error_mini_batch: "Қайтару mini batch",
    l_Work: "Жұмыс",
    l_China_logistics: "Қытай логистикасы",
    l_Receiver: "Қабылдаушы",
    l_Transport_day: "Тасымалдау күні",
    l_Day: "Күн",
    l_tel_merge: "Телефонды біріктіру",
    l_Abnormal_order: "Мәселелі тапсырыс",
    l_Customs: "Кеден",
    l_Contract: "Келісімшарт",
    l_Invoice: "Invoice",
    l_Filter: "Фильтр",
    l_CN_category_id: "CN категориясының идентификаторы",
    l_Prohibited_catgegories: "Тыйым салынған санат",
    l_Error: "Техникалық қателік орын алды! IT бөліміне скрин жіберіңіз.",
    l_Those_whose_weight_is_over_31_kg: "Салмағы 31 кг-нан асқандар",
    l_The_price_is_more_than_1000: "Бағасы 1000$ асқандар",
    l_Price_over_1000_and_weight_over_31_kg: "Бағасы 1000$ асқандар және салмағы 31 кгнан асқандар",
    l_Net_weight: "Таза салмақ",
    l_Overall_weight: "Жалпы салмақ",
    l_History: "Тарихы",
    l_Updated_time: "Өзгертілген уақыт",
    l_Order_count: "Тапсырыс саны",
    l_Unknown: "Белгісіз",
    l_Mini_batch_count: "Mini batch саны",
    l_Return_order: "қайтарылған тапсырыс",
    l_Change_branch: "Бөлімше өзгерту",
    l_Image: "Сурет",
    l_Search_in_shelf: "Сөреден іздеу",
    l_Translation: "Аударма",
    l_Primary_language: "Бастапқы тіл",
    l_Content: "Мазмұны",
    l_Translated_language: "Aударылған тіл",
    l_Check_the_category_of_KTZ: "KTZ категориясын тексеру",
    l_There_is_KTZ_category: "KTZ категориясы бар",
    l_There_is_no_category_KTZ: "KTZ категориясы жок",
    l_Statistic: "Статистика",
    l_Are_you_sure_of_the_correctness_of_the_data: "Деректердің дұрыстығына сенімдісіз бе?",
    l_China_warehouse: "Қытай қоймасы",
    l_Sorting: "Сұрыптау",
    l_Role: "Рөл",
    l_Stay_branch_day: "Бөлімшеде тұрған күн (мин)",
    l_Min_weight: "Салмақ (мин)",
    l_Menu: "Меню",
    l_Left_from_Almaty: "Алматыдан шықты",
    l_Left_from_China: "Қытайдан шықты",
    l_Almaty_warehouse_received: "Алматы қоймасы қабылдап алды",
    l_China_warehouse_received: "Қытай қоймасы қабылдап алды",
    l_Jpid_build_by_minibatch: "Minibatch-ка салған jpid",
    l_Weighed_id: "Салмағын өлшеген id",
    l_Close: "Жабу",
    l_Article: "Мақала",
    l_Employees: "Қызметкерлер",
    l_Visibility: "Көріну",
    l_Can_view: "Көруге болады",
    l_Admin_worker: "Админ қызметкері",
    l_Web: "Веб",
    l_General: "Жалпы",
    l_Door_to_door: "Маған жеткізу",
    l_Pending_orders: "Күтудегі тапсырыстар",
    l_In_delivery: "Жеткізілуде",
    l_Received: "Алынды",
    l_Reject: "Қабылдамау",
    l_Pending: "Күтілуде",
    l_Supervision: "Қадағалау",
    l_Language: "Тілі",
    l_Agent: "Агент",
    l_My_Statistics: "Менің статистикам",
    l_Count_Stats: "Санақ статистикасы",
    l_Number_of_products_that_do_not_match_the_branch: "Филиал сәйкес емес тауарлар саны",
    l_Quantity_of_goods: "Тауарлар саны",
    l_Batch_statistics: "Batch статистика",
    l_Returned_to_China_Courier: "Қытай курьеріне қайтарылды",
    l_Feedback: "Кері байланыс",
    l_Accepted: "Қабылданды",
    l_In_progress: "Орындалуда",
    l_Weight_change_history: "Салмақ өзгерту тарихы",
    l_Public_document: "Қоғамдық құжат",
    l_Recovery: "Қалпына келтіру",
    l_Logistic: "Логистика",
    l_Regional_center: "Облыс (Қала) орталығы",
    l_Internal_logistics: "Ішкі логистика",
    l_Branch: "Бөлімше",
    l_Dont_match: "Сәйкес емес",
    l_Additional_document: "Қосымша құжат",
    l_Weight_difference: "Салмақ айырмашылығы",
    l_Dead_goods: "Өлі тауар",
    l_List: "Тізімі",
    l_Result: "Нәтиже",
    l_Reason: "Себеп",
    l_Negotiate_order_prices: "Тапсырыс бағасын келісу",
    l_Negotiate_road_prices: "Жол бағасын келісу",
    l_Bank_account: "Банк шоты",
    l_Finish: "Аяқтау",
    l_Revise: "Қайта тексеру",
    l_Alert_on_revision: "Тексеру уақыты басталмады",
    l_Save: "Сақтау",
    l_Create: "Құру",
    l_Schedule: "Кесте",
    l_Coming: "Жолда",
    l_Reception: "Қабылдау",
    l_Put_on_the_shelf: "Сөреге қою",
    l_Distribution: "Тарату",
    l_Result_status: "Нәтиже күйі",
    l_Tag: "Тег",
    l_Average_weight: "Орташа салмақ",
    l_Dependent_region: "Тәуелді аймақ",
    l_Reset_permission: "Рұқсатты қалпына келтіру",
    l_Cannot_be_deleted: "Жою мүмкін емес",
    l_Region: "Регион",
    l_Operator_statistic: "Оператор статистикасы",
    l_People_who_uploaded_the_document: "Құжатты жүктеген адамдар",
    l_Reset: "Қалпына келтіру",
    l_Rejected_order: "Бастартылған тапсырыс",
    l_Warning_Has_an_impact_on_statistics: "Ескерту! Статистикаға әсері бар.",
    l_Fragile_products: "Оңай сынатын тауарлар",
    l_Sorting_machine: "Сұрыптау аппарат",
    l_Unique: "Бірегей",
    l_Repeated: "Қайталанатын",
    l_Machine: "Аппарат",
    l_Ticket: "Билет",
    l_Work_schedule: "Жұмыс кестесі",
    l_App_service: "App қызметі",
    l_Badge: "Бейдж",
    l_Services: "Сервистер",
    l_Order_status: "Тапсырыс күйі",
    l_In_several_branches: "Бірнеше бөлімшеде",
    l_Not_in_database: "Базада жоқ",
    l_Correct: "Дұрыс",
    l_Revision: "Ревизия",
    l_Detail: "Толық мәлімет",
    l_Default: "Әдепкі",
    l_New: "Жаңа",
    l_Soon: "Жуырда",
    l_Answer: "Жауап",
    l_Receive_client: "Клиенттен қабылдау",
    l_Work_order: "Жұмыс тапсырысы",
    l_Order_code: "Тауар-код",
    l_Send_address: "Жіберу мекенжайы",
    l_Receive_name: "Алушының аты",
    l_Receive_contact: "Алушы контактісі",
    l_Receive_address: "Алушы мекенжайы",
    l_Express_Company_Id: "Экспресс компания идентификаторы",
    l_Express_Dealer: "Express жеткізуші",
    l_Express_Dealer_Contact: "Жеткізуші контактісі",
    l_Compensate_Amount: "Компенсация сомасы",
    l_Reply_type: "Жауап түрі",
    l_Handle_result: "Нәтижені өңдеу",
    l_Call_result: "Қоңырау нәтижесі",
    l_Pay_amount: "Тауар бағасы",
    l_Compensate_state: "Компенсация күйі",
    l_sign_state: "Белгі күйі",
    l_Replied: "Жауап берді",
    l_Not_replied: "Жауап берілген жоқ",
    l_Orders_in_shelf: "Сөредегі тауарлар саны",
    l_Tariff: "Тариф",
    l_Filter_settings: "Сүзгі баптаулары",
    l_PDD_received: "PDD қабылдады",
    l_Wallet: "Шот",
    l_Bonus: "Бонус",
    l_Refund_account: "Қайтарымға жауапты",
    l_Duty: "Жауапты жақ",
    l_The_call_was_connected_but_there_was_no_response: "Қоңырау қосылды, бірақ жауап болмады",
    l_Wrong_number: "Қате нөмір",
    l_Phone_is_busy: "Телефон бос емес",
    l_No_response: "Жауап жоқ",
    l_Other_person: "Басқа адам",
    l_By_default: "Әдепкі бойынша",
    l_Not_signed: "Қол қойылған жоқ",
    l_Signed: "Қол қойылған",
    l_Cargo_company: "Жүк тасымалдау компаниясы",
    l_Seller: "Сатушы",
    l_Will_not_compensate: "Өтеу төленбейді",
    l_Will_compensate: "Өтемдеймін",
    l_Answered: "Кім жауап берді",
    l_Replied_at: "Жауап берілген уақыт",
    l_Consumer: "Тұтынушы",
    l_Multi: "Көп",
    l_Normal: "Қалыпты",
    l_Added_to_task: "Тапсырмаға қосылды",
    l_Big_box: "Үлкен қорап",
    l_Task: "Тапсырма",
    l_Has: "бар",
    l_None: "Жоқ",
    l_All_answers: "Барлық жауаптар",
    l_Already_scanned: "Сканерленген!",
    l_Terminal: "Терминал",
    l_The_branch_does_not_match: "Филиал сәйкес емес",
    l_End_time: "Аяқталу уақыт",
    l_Left: "Шықты",
    l_Reached_the_center: "Орталыққа жетті",
    l_Left_from_the_center: "Орталықтан шықты",
    l_Scan_time: "Сканерлеу уақыт",
    l_App_news: "Қолданба жаңалықтары",
    l_Title: "Тақырып",
    l_Check_list: "Тексеру тізімі",
    l_Total_average: "Жалпы орташа балл",
    l_Operation_JPID: "JPID операциясы",
    l_Average_score: "Орташа балл",
    l_Criteria_name: "Шарттар атауы",
    l_Score: "Ұпай",
    l_Check_list_add: "Тексеру тізімін қосу",
    l_Criteria_add: "Шарттарды қосу",
    l_Checked_date: "Тексеру күні",
    l_User_restore: "Қолданушыны қалпына келтіру",
    l_App_articles: "Қолданба мақалалары",
    l_Partner: "Серіктес",
    l_News: "Жаңалықтар",
    l_Lost: "Адасқан",
    l_Video: "Кескін",
    l_Statement: "Өтініш",
    l_Serve_speed: "Жіберу жылдамдығы",
    l_Send_by_file: "Файл арқылы жіберу",
    l_Send_one: "Біртіндеп жіберу",
    l_Late_goods: "Кешіккен тауар",
    l_Warehouse_payment: "Склад төлем",
    l_Registration: "Тіркеу",
    l_Questions: "Сұрақтар",
    l_Question: "Сұрақ",
    l_Rating: "Бағалаулар",
    l_Star: "Жұлдыз",
    l_Sender: "Жіберуші",
    l_Rate_type: "Бағалау түрі",
    l_Rate_question: "Сауалнама",
    l_Scan_with_app: "Jana Post қосымшасымен сканер жасаңыз",
    l_Destroy: "Жою",
    l_Sold: "Сатылды",
    l_Burned: "Күйіп кетті",
    l_Rework: "Қайта өңдеу",
    l_Worker: "Жұмысшы",
    l_Delivery: "Орындалу уақыты",
    l_Send: "Жіберу",
    l_Destroyed: "Жойылды",
    l_File_must_be_less_than_5_MB: "Файл 5 МБ-тан аз болуы керек!",
    l_Finish_sorting: "Сұрыптау аяқталды",
    l_Barcode: "Штрих-код",
    l_Inner_logistic_finish: "Ішкі логистика аяқталды",
    l_Table: "Кесте",
    l_Charts: "Диаграммалар",
    l_Option: "Талдау",
    l_Options: "Талдаулар",
    l_Results: "Қорытынды жауап",
    l_Partners: "Серіктестер",
    l_Resume: "Резюме",
    l_Finance: "Қаржы",
    l_Scanzona: "Зонада",
    l_Scanned_in_zona: "Зонада сканерленген",
    l_Complaints: "Шағымдар",
    l_Responsible_department: "Жауапты бөлім",
    l_User_feedback: "Қолданушының пікірі",
    l_Recipient_stats: "Алушылар статистикасы",
    l_Employee_discount: "Қызметкерлерге жеңілдік",
    l_Transportation_time: "Тасымалдау уақыты",
    l_Hour: "Сағат",
    l_Add_filials: "Филиалдар қосу",
    l_Filial_list: "Филиалдар тізімі",
    l_Partnership: "Әріптестік",
    l_Count: "Бөлінген орын саны",
    l_Branches_for_partners: "Партнерлерге ашылатын филиалдар",
    l_Plomb: "Пломба",
    l_Latitude: "Ендік",
    l_Longitude: "Бойлық",
    l_By_file: "Файл бойынша",
    l_By_filter: "Сұрыптау бойынша",
    l_User_count: "Қолданушы саны",
    l_Name_fill: "Аты жөніңіз",
    l_individualEntrepreneur: "Сізде ИП ашылған ба? ",
    l_Address_link: "Бөлімше ашатын орынды 2GIS қосымшасынан сілтемесін енгізіңіз және кв.метрін көрсетіп қысқаша ақпарат жазыңыз",
    l_Have_you_ordered: "JANA POST компаниясы арқылы тапсырыс беріп көргенсіз бе? (JP код жазу керек)",
    l_Address_fill: "JANA POST компаниясының талаптарына сай бөлімше ашатын орыныңыз бар ма? ",
    l_Based_on_your_current_location_are_you_in_Kazahstan: "Қазіргі орналасқан жеріңізге байланысты сіз Қазақстандасыз",
    l_Based_on_your_current_location_are_you_in_Uzbekistan: "Қазіргі орналасқан жеріңізге байланысты сіз Өзбекстандасыз",
    l_Based_on_your_current_location_are_you_in_Kyrgyzstan: "Қазіргі орналасқан жеріңізге байланысты сіз Қырғызстандасыз",
    l_Based_on_your_current_location_are_you_in_Tajikistan: "Қазіргі орналасқан жеріңізге байланысты сіз Тәжікстандасыз",
    l_Based_on_your_current_location_are_you_in_Mongolia: "Қазіргі орналасқан жеріңізге байланысты сіз Монғолиядасыз",
    l_Continue: "Жалғастыру",
    l_Access_to_geodata_is_not_allowed: "Геодеректерге қол жеткізу рұқсат етілмеген. Орналасқан жеріңізді анықтау мүмкін емес",
    l_Location_information_is_unavailable: "Орналасқан жер туралы ақпарат қолжетімді емес.",
    l_your_bday: "Туған жыл, ай, күніңіз",
    l_knowledge: "Біліміңіз",
    l_is_there_experience: "Бизнесті жүргізу, адамдарды басқару және ұйымдастыруда тәжірибеңіз бар ма?",
    l_is_there_2million: "Филиал ашуға орта есеппен 2млн басталатын алғашқы жарнаңыз бар ма?",
    l_Lower: "Арнайы кәсіптік",
    l_Middle: "Орта білім",
    l_Upper: "Жоғары",
    l_Add_partners: "Серіктес қосу",
    l_Communication: "Хабарласу",
    l_Area_covered: "Қамтылатын аймақ",
    l_Document_service: "Құжат қызметі",
    l_The_shelf_number_should_start_with_JP: "Сөре нөмірі JP басталу керек",
    l_All_near_branches: "Барлық жақын орналасқан филиалдар",
    l_Important: "Маңызды",
    l_New_station: "Жаңа бөлімше ашу",
    l_Branch_near_by: "Жақын жерде орналасқан филиалдар",
    l_Branch_open_warehouse: "Ашылған филиалдар",
    l_Need_branch: "Филиалды таңдау керек",
    l_Daily_Count_Stats: "Күндік көрсеткіш",
    l_Agreement_branch: "Келісімшарт (Бөлімше)",
    l_Agreement_sign: "Келісімшартқа қол қою",
    l_Batch_not_installed: "Batch салынбаған",
    l_Excel_print: "Excel шығару(тапсырыс)",
    l_Reading_list: "Оқығандар тізімі",
    l_Marketing: "Маркетинг",
    l_Number: "Саны",
    l_Home_delivery: "Үйге жеткізу",
    l_Matching: "Сәйкестендіру",
    l_Call_center: "Call center",
    l_Track_analytic: "Тапсырыс аналитикасы",
    l_On_the_shelf: "Сөреде",
    l_Delivered: "Жеткізілді",
    l_Available_offers: "Қолжетімді ұсыныстар",
    l_Courier: "Курьер",
    l_Enabled: "Ашық",
    l_Disabled: "Жабық",
    l_Identification_to_branch: "Филиалына сәйкестендіру",
    l_Personal: "Жеке",
    l_Finished_the_job: "Жұмысты аяқтады",
    l_Completeness: "Тұтастық",
    l_Timeliness: "Уақыттылығы",
    l_Timeliness_24h: "Уақыттылығы 24 сағат",
    l_On_time_delivery: "Уақытылы жеткізу",
    l_On_time: "Уақытылы",
    l_Late: "Кеш",
    l_Total: "Барлығы",
    l_Percent: "Пайыз",
    l_Margin: "Маржа",
    l_Loss: "Шығын",
    l_Income: "Табыс",
    l_Today: "Бүгін",
    l_Yesterday: "Кеше",
    l_Day_before_yesterday: "Алдыңғы күні",
    l_Last_status: "Соңғы статус",
    l_Static_tracks: "Қозғалыссыз тапсырыстар",
    l_Preparation_for_distribution: "Бөлуге дайындау",
    l_Mini_batch_destination: "M-Batch баратын бөлімше",
    l_Not_matched_stations: "Филиал сәйкес емес тауарлар",
    l_Count_order_mbatch: "M-Batch барлық тауар саны",
    l_No_branches_choosed: "Бөлімше таңдалмаған",
    l_Agree_to_change_branches: "Батырманы басып, сіз барлық тауардың филиалын осы M-Btach таңдаған филиалға ауыстырасыз",
    l_Change: "Өзгерту",
    l_Distribution_to_the_basket: "Себетке бөлу",
    l_Coordinate_status: "Координаталық күй",
    l_Delivery_status: "Жеткізу күйі",
    l_Number_of_baskets: "Себеттер саны",
    l_Basket_add: "Себетке қою",
    l_Basket_number: "Себет номері",
    l_Courier_reseived: "Курьер алды",
    l_Courier_didnt_reseived: "Курьер алмады",
    l_Courier_jpcr: "Курьер JPCR",
    l_Need_to_scan_the_courier_JPCR: "Курьер JPCR-ды сканерлеу керек",
    l_Need_to_scan_the_basket_number: "Себет нөмірін сканерлеу керек",
    l_First_scan_the_basket_number_to_check_the_status: "Cебет нөмірін сканерлеп, статусын тексеруге болады",
    l_Last_time: "Соңғы өзгеріс",
    l_Clear: "Тазалау",
    l_Basket_list: "Себет тізімі",
    l_Withdrawal_of_an_order: "Тапсырысты қайтарып алу",
    l_Basket: "Себет",
    l_Adding_an_order_to_the_shelf: "Тапсырысты сөреге қосу",
    l_Distribution_of_the_order_in_the_basket: "Тапсырысты себетке бөлу",
    l_Couriers: "Курьерлер",
    l_To_divide_the_basket_you_need_to_add_the_order_to_the_shelf: 'Тапсырысты себетке бөлу үшін тапсырысты сөреге қосу керек немесе жеткізі күйі "Бөлу дайындалуда" болу керек !  ',
    l_Only_those_whose_coordinates_are_found_are_allocated_in_the_basket: "Координаталары табылғандар ғана себетке бөлінеді",
    l_Orders_in_the_basket: "Себеттегі тапсырыстар",
    l_Courier_refused: "Курьер бас тартты",
    l_Recommended_basket: "Ұсынылған себет",
    l_Number_of_goods_in_preparation_for_distribution: "Бөлуге дайындалудағы тауарлар саны",
    l_Frozen_state: "Мұздатылған күйі",
    l_Be_careful_when_freezing_the_order: "Тапсырысты мұздатқан кезде абай болыңыз !",
    l_Branch_orders: "Филиал тапсырыстары",
    l_Problem_description: "Мәселенің сипаттамасы",
    l_Go_to_website: "Сайтқа өту",
    l_Invite_list: "Шақырылғандар тізімі",
    l_Inviter_JPID: "Шақырушының JPID",
    l_Add_order_to_the_Basket: "Себетке тапсырысты қосу",
    l_Preparing_the_basket_in_the_order: "Тапсырысты себетке дайындау",
    l_Write_the_number_of_the_basket_where_the_orders_will_be_placed: "Тапсырыстар орналасатын себет нөмірін жазыңыз!",
    l_Order_withdrawal_from_courier: "Курьерден қайтарып алу",
    l_Distribution_of_the_order_to_the_courier_shelf: "Тапсырысты курьер сөресіне бөлу",
    l_Courier_shelf_list: "Курьерлік сөре тізімі",
    l_Orders_on_the_courier_shelf: "Курьер сөресіндегі тапсырыстар",
    l_Placing_the_order_on_the_courier_shelf: "Тапсырысты курьерлік сөреге қою",
    l_Courier_shelf_number: "Курьерлік сөре нөмірі",
    l_Preparing_the_order_for_the_courier_shelf: "Тапсырысты курьер сөресіне дайындау",
    l_Adding_an_order_to_the_courier_shelf: "Курьерлік сөреге тапсырыс қосу",
    l_Place_on_the_courier_shelf: "Курьер сөресіне қою",
    l_Allocation_to_the_courier_rack: "Курьер сөресіне бөлу",
    l_Division_into_shelves: "Сөреге бөлу",
    l_Shipping_price: "Жеткізу бағасы",
    l_Cost_price: "Өзіндік құн",
    l_NORTH: "СОЛТҮСТІК",
    l_SOUTH: "ОҢТҮСТІК",
    l_WEST: "БАТЫС",
    l_EAST: "ШЫҒЫС",
    l_Over45days: "45 күннен асқан",
    l_Text: "Текст",
    l_Order_rectify: "Тапсырысты жөндеу",
    l_Not_received: "Алынбады",
    l_Department: "Бөлім",
    l_Operation_time: "Операциялық уақыт",
    l_Tracks: "Тректер",
    l_Adding_a_courier_order: "Курьерге тапсырыс қосу",
    l_Sending_to_courier: "Курьерге жіберу",
    l_Regulation: "Реттеу",
    l_Orders_that_should_be_frozen: "Мұздату керек тапсырыстар",
    l_On_the_courier: "Курьерде",
    l_Goods_older_than_15_days: "15 күннен асқан тауарлар",
    l_Frozen: "Мұздатылған",
    l_Late_delivered_orders: "Кеш жеткізілген тапсырыстар",
    l_More_details: "Толығырақ",
    l_Number_of_days: "Күндер саны",
    l_Undelivered_goods: "Жеткізілмеген тауарлар",
    l_Client_received: "Клиент алды",
    l_Stuck_orders: "Тұрып қалған тапсырыстар",
    l_Check: "Тексеру",
    l_District: "Аудан",
    l_Store: "Дүкен",
    l_Route: "Рейс",
    l_Branch_batch_count: "Branch batch саны",
    l_Last_freeze_day: "Соңғы мұздату күні",
    l_Level: "Деңгей",
    l_Undelivered: "Жеткізілмеген",
    l_New_user: "Жаңа қолданушы",
    l_Sending_a_verification_code_to_the_client: "Клиентке растау кодын жіберу",
    l_Confirmation_code: "Растау коды",
    l_Transit_count: "Транзит саны",
    l_Wrong_tracks: "Қате тректер",
    l_Normal_tracks: "Қалыпты тректер",
    l_Goods_lost_or_broken: "Тауар жоғалды немесе сынды",
    l_Load_data: "Деректерді жүктеу",
    l_China_storage: "Қытай қоймасы",
    l_Inner_logistics: "Ішкі логистика",
    l_Warning: "Ескерту",
    l_Penalty: "Штраф",
    l_Day_left_to_return: "Қайтаруға күн қалды",
    l_Reason_for_rejection: "Бастарту себебі",
    l_Rejection: "Бастарту",
    l_DepartmentId: "Төлеуші бөлім",
    l_Patronymic: "Әкесінің аты",
    l_Inviter: "Шақырушы",
    l_Awaiting_a_refund: "Ақша қайтаруды күтуде",
    l_Send_push_message: "Push-хабарлама жіберу",
    l_Order_search: "Тапсырыс іздеу",
    l_Exported: "Жолға шықты",
    l_Arrival_transfer_center: "Трансфер орталына жетті (Қорғас)",
    l_Export_clearance_start: "Экспорттық кедендік рәсімдеу басталды",
    l_Export_clearance_finish: "Экспортқа кедендік рәсімдеу аяқталды",
    l_Departure_foreign: "Шетелден шықты",
    l_Reached_Kazakhstan: "Қазақстанға жетті",
    l_Import_clearance_start: "Импорттық кедендік рәсімдеу басталды",
    l_Import_clearance_finish: "Импорттық кедендік рәсімдеу аяқталды",
    l_Package_status: "Қаптама күйі",
    l_Arrival_branch: "Бөлімшеге жетті",
    l_KZ_mini_batch_products: "KZ mini batch салынған тауарлар",
    l_Scanned: "Сканерленген",
    l_More: "Көбірек",
    l_Chinese_address: "Қытай мекен-жайы",
    l_Fill_in_the_information: "Ақпаратты толтырыңыз",
    l_Day_delivered: "күнде жеткізілді",
    l_Day_delivering: "күн жеткізілуде",
    l_Client_address: "Клиенттің мекенжайы",
    l_Warehouse_address: "Қойма мекенжайы",
    l_Domestic_Express__Affordable_Prices: "Отандық жедел жеткізу",
    l_Resubmit: "Қайта жіберу",
    l_Add_language: "Тіл қосу",
    l_Create_discount: "Жеңілдікті қосу",
    l_Please_enter_jpid: "JPID енгізіңіз",
    l_Video_guide: "Бейне нұсқаулық",
    l_Max_upload_weight: "Максималды өлшем — {size}",
    l_Story_feed: "Стористер лентасы",
    l_Story: "Стори",
    l_Media: "Медиа",
    l_Button: "Батырма",
    l_Marketplace: "Маркетплейс",
    l_China_warehouse_address: "Қытай қоймасының мекенжайы",
    l_After_copy_url: "Көшіруден кейінгі URL",
    l_Confirm_action: "Әрекетті растаңыз.",
    l_VIP_client: "VIP клиент",
    l_Notification: "Хабарлама",
    l_Back_to_school: "Back to school",
    l_Categories: "Категориялар",
    l_Add_category: "Категория қосу",
    l_Add_subcategory: "Подкатегория қосу",
    l_Subcategory: "Подкатегория",
    l_Hidden: "Жасырын",
    l_Products: "Тауарлар",
    l_Add_bts_product: "Тауар қосу",
    l_Product_link: "Тауар сілтемесі",
    l_Horizontal_placement: "Көлденең орналасады",
    l_Limit: "Лимит",
    l_Characters: "таңба",
    l_Enter_https_url: "Жарамды https URL енгізіңіз",
    l_Push_category: "Push категория",
    l_By_category: "Категория бойынша",
    l_Min_count_required: "Кемінде {count} {element} болуы керек",
    l_Max_count_allowed: "Максимум {count} {element} болуы мүмкін",
    l_Only_latin_letters_allowed: "Тек латын әріптері, сандар, “-”, “_”",
    l_Error_500: "Сервердің ішкі қатесі. Кейінірек қайталап көріңіз.",
    l_Janapost_link: "JanaPost сілтеме",
    l_Internal_link: "Ішкі сілтеме",
    l_External_link: "Сыртқы сілтеме",
    l_Shared_link: "Ортақ сілтеме",
    l_Upload_video: "Видео жүктеу",
    l_Enter_link: "Сілтеме енгізу",
    l_Buttons: "Батырмалар",
    l_Add_Image_and_buttons: "Сурет пен батырмаларды қосу",
    l_Free_delivery: "Тегін жеткізу",
    l_Statistics: "Статистика",
    l_Mastercard_payments: "Mastercard төлемдері",
    l_Total_payment_amount: "Төлем соммасы",
    l_Promotion_amount: "Жеңілдікпен соммасы",
    l_Total_payment_count: "Төлем саны",
    l_Total_unique_users: "Уникалды қолданушылар саны",
    l_Please_fill_in_this_field: "Бұл өрісті толтыруыңызды сұраймыз",
    l_Deleted_accounts: "Жойылған тіркелгілер",
    l_Context: "Контекст",
    l_Reasons_for_account_deletion: "Аккаунт жою себептері",
    l_Client_type: "Клиент түрі",
    l_Client_filter: "Клиент фильтрі",
    l_By_has_order: "Тапсырыстар бойынша",
    l_By_the_order_time: "Тапсырыс уақыты бойынша",
    l_Push_send_confirm: "Хабарлама {count} қолданушыға жіберіледі! Саны дұрыс па?",
    l_Has_order_yes: "Тапсырысы бар",
    l_Has_order_no: "Тапсырысы жоқ",
    l_Select_has_order: "Тапсырысы бар/жоқ таңдаңыз",
    l_Select_order_time: "Тапсырыс уақытын таңдаңыз",
    l_Stories: "Стористер",
    l_Stories_banner_statistics: "Стористер статистикасы",
    l_Max_day_count: "Таңдауға болатын уақыт аралығы: {count} күн",
    l_Error_occured: "Қателік орын алды. Кейін қайталап көріңіз.",
    l_Promo_code: "Промокод",
    l_Common: "Жалпы",
    l_System_send: "Жүйелік жіберу",
    l_Enter_promo_code: "Промокод / JPID / телефон нөмірін енгізіңіз",
    l_Owner: "Иесі",
    l_Bonus_discount: "Бонус / Жеңілдік",
    l_Enter_bonus_amount: "Бонус сомасын енгізіңіз",
    l_Usage_count: "Пайдалану саны",
    l_Expiration_date: "Жарамдылық мерзімі",
    l_Enter_expiration_date: "Жарамдылық мерзімін енгізіңіз",
    l_Active: "Белсенді",
    l_Inactive: "Белсенді емес",
    l_Expired: "Жарамсыз",
    l_View: "Көру",
    l_Disable: "Сөндіру",
    l_Platform: "Платформа",
    l_Device: "Құрылғы",
    l_Conversion: "Конверсия",
    l_Earned_bonus: "Алынды бонус",
    l_Burned_bonus: "Айырылған бонус",
    l_System_promo_code: "Жүйелік промокод",
    l_Distribution_channels: "Тарату арналары",
    l_Enter_description: "Сипаттама / қосымша ақпарат енгізіңіз",
    l_Select_at_least_one_distribution_channels: "Кем дегенде 1 тарату каналын таңдаңыз",
    l_Old_first: "Ескілер бірінші",
    l_New_first: "Жаңалары бірінші",
    l_User_promo_code: "Қолданушы промокоды",
    l_Enter_title_in_ru: "Тақырыпты орыс тілінде енгізіңіз",
    l_Enter_title_in_kk: "Тақырыпты қазақ тілінде енгізіңіз",
    l_Enter_description_in_ru: "Сипаттаманы орыс тілінде енгізіңіз",
    l_Enter_description_in_kk: "Сипаттаманы қазақ тілінде енгізіңіз",
    l_Send_count: "Жіберу саны",
    l_Expired_count: "Жарамсыздар саны",
    l_Used_amount: "Пайдаланылған сомма",
    l_Expired_amount: "Жарамсыздар соммасы",
    l_Date_type: "Уақыт түрі",
    l_Period: "Период",
    l_Are_you_sure_to_off_promocode: "Сіз промокодты сөндіруге сенімдісіз бе?",
    l_Are_you_sure_to_on_promocode: "Сіз промокодты қосуға сенімдісіз бе?",
    l_Please_fill_all_fields: "Барлық өрістерді толтыруыңызды сұраймыз",
    l_Please_select_a_promo_code: "Промокодты таңдаңыз",
    l_Are_you_sure_in_filled_fields: "Сіз толтырылған өрістердің дұрыстығына сенімдісіз бе?",
    l_Last_usage_time: "Соңғы қолдану уақыты",
    l_Loading: "Жүктеліп жатыр, күте тұруыңызды сұраймыз...",
    l_Kazakhstan: "Қазақстан",
    l_Kyrgyzstan: "Қырғызстан",
    l_Uzbekistan: "Өзбекстан",
    l_Tajikistan: "Тәжікстан",
    l_Mongolia: "Монғолия",
    l_Promo_disabled: "Промокод сәтті сөндірілді",
    l_Promo_enabled: "Промокод сәтті қосылды",
    l_Field_cannot_be_empty: "Бұл өріс бос болмауы керек",
    l_Push_sent_successfully: "Push-хабарлама сәтті жіберілді",
    l_Successfully_updated: "Сәтті жаңартылды",
    l_Kazakh: "Қазақша",
    l_Russian: "Орысша",
    l_English: "Ағылшынша",
    l_Currency: "Валюта",
    l_Select_currency: "Валютаны таңдаңыз",
    l_Successfully_created: "Сәтті құрылды",
    l_Something_went_wrong: "Қателік орын алды. Кейінірек қайталап көріңіз.",
    l_Must_be_more_than_zero: "Сома нөлден көп болуы керек",
    l_User_send_count: "Жіберілгендер саны",
    l_Active_time: "Актив уақыты",
    l_For_one_promocode: "Бір промокод",
    l_Promocode_expired: "Промокодтың жарамдылық уақыты өтіп кетті",
    l_By_days: "Күн арқылы",
    l_By_exact_date: "Нақты уақыт",
    l_Enter_days: "Күн таңдаңыз (өзгеріс бүгіннен есептеледі)",
    l_Please_wait_seconds: "Бірнеше секунд күтуңізді сұраймыз.",
    l_This_sign_is_not_allowed: "Бұл таңбаны енгізуге болмайды",
    l_Promo_code_title: "Промокодтың атауы",
    l_Redemption_policy: "Промокодты пайдалану шарттары",
    l_Standard: "Стандарт",
    l_Single_use_burn_remainder: "Бір рет қолданылу(Қалған бонус жойылады)",
    l_Select_redemption_policy: "Промокодты пайдалану шарттарын таңдаңыз",
    l_Enter_promo_code_only: "Промокод атауын енгізіңіз",
    l_Remote_config: "Remote config",
    l_Remote_config_info: "Ақпарат",
    l_Remote_config_social: "Әлеуметтік желілер",
    l_Remote_config_legal: "Заңды құжаттар",
    l_Remote_config_features: "Функциялар",
    l_Remote_config_devmode: "Тест режимі",
    l_Remote_config_home_page_promo_icon: "BTS config",
    l_Remote_config_image_url: "Сурет URL",
    l_Remote_config_general: "Жалпы",
    l_Remote_config_bin: "БСН",
    l_Remote_config_about_app: "Қолданба туралы",
    l_Remote_config_search_url: "Іздеу URL",
    l_Remote_config_contact: "Байланыс",
    l_Remote_config_feedback_email: "Кері байланыс email",
    l_Remote_config_feedback_url: "Кері байланыс URL",
    l_Remote_config_support_service: "Қолдау қызметі",
    l_Remote_config_app_url: "App URL (deeplink)",
    l_Remote_config_web_url: "Web URL",
    l_Remote_config_public_contract: "Жария шарт",
    l_Remote_config_agreement: "Келісім",
    l_Remote_config_tracking_numbers: "Тест трекинг нөмірлері",
    l_Remote_config_social_facebook: "Facebook",
    l_Remote_config_social_instagram: "Instagram",
    l_Remote_config_social_tiktok: "TikTok",
    l_Remote_config_social_youtube: "YouTube",
    l_Remote_config_social_telegram: "Telegram",
    l_Remote_config_social_whatsapp: "WhatsApp",
    l_Remote_config_feature_education: "Оқыту",
    l_Remote_config_feature_domestic: "Ішкі жеткізу",
    l_Remote_config_feature_addOrder: "Тапсырыс қосу",
    l_Remote_config_feature_inviteFriend: "Дос шақыру",
    l_Remote_config_feature_copyAddress: "Мекенжайды көшіру",
    l_Delete: "Жою",
    l_Value: "Мән",
    l_Home_banner: "Баннер",
    l_Add_home_banner: "Баннер қосу",
    l_Update_home_banner: "Баннерді жаңарту",
    l_Show_period: "Көрсету мерзімі",
    l_Show_period_hint: "Көрсету мерзімін енгізіңіз",
    l_No_period_limit: "Период шектеуі жоқ",
    l_Views: "Көрсетілім",
    l_Clicks: "Басулар",
    l_Statistics_update_hint: "Статистика тәулігіне бір рет жаңартылады",
    l_Manage_order: "Реттілікті басқару",
    l_Url: "Сыртқы сілтеме",
    l_App_section: "Қолданба бөлімі",
    l_Show_from: "Көрсету басталатын уақыт",
    l_Show_to: "Көрсету аяқталатын уақыт",
    l_Enter_sort_number: "Сұрыптау нөмірін енгізіңіз",
    l_Preview: "Превью",
    l_Select_language_to_reorder: "Реттілікті өзгерту үшін тілді таңдаңыз",
    l_No_data: "Деректер жоқ",
    l_End_time_cannot_be_in_past: "Өткен уақытта қоя алмайсыз",
    l_Active_now: "Белсенді",
    l_Scheduled: "Жоспарланған",
    l_Copied: "Көшірілді",
    l_New_version_logo: "Жаңа лого",
    l_New_version_video: "Жаңа нұсқа видеосы",
    l_Until: "{time} дейін",
    l_From: "{time} бастап",
    l_How_to_fill_link_field: "Сілтеме өрісін қалай толтыру керек",
    l_Opens_screen_inside_app: "қосымша ішіндегі экранды ашады.",
    l_Allowed_values: "Рұқсат етілген мәндер",
    l_Unknown_module_banner_not_open: "Басқа кез келген мән — баннер ештеңе ашпайды.",
    l_Opens_external_link_examples: "сыртқы сілтемені ашады. Мысалдар",
    l_Website: "Сайт",
    l_App_not_installed_web_fallback: "Егер қосымша (WhatsApp, Telegram және т.б.) орнатылмаған болса — веб-нұсқа автоматты түрде ашылады.",
    l_Branches: "Бөлімшелер",
    l_Pickup: "Алып кету беті",
    l_Enter_valid_link: "Дұрыс сілтеме енгізіңіз (https://... немесе deep link)",
    l_Module_value_type: "Нені ашу",
    l_From_list: "Тізімдегі бөлім",
    l_Banner_link_help_title: "Баннерді басқанда не болады",
    l_Help_url_desc: "сыртқы сілтемені браузерде немесе қосымшада ашады. Мысалдар:",
    l_Help_module_desc: "контентті біздің қосымша ішінде ашады. Екі нұсқа:",
    l_Help_module_list_desc: "дайын экранды ашады (Jana Drive, Бөлімшелер, FAQ және т.б.)",
    l_Help_module_url_desc: "сілтемені қосымша ішінде ашады (WebView), браузерге шықпай",
    l_Url_short: "Сілтеме",
    l_Help_module_only_five_note: "Әзірге тізімде тек 5 бөлім қолжетімді: Jana Drive, Бөлімшелер, FAQ, Pickup, Баптаулар. Басқа бөлімдерді сілтеме арқылы байланыстыру қажет. Баннерді басқа бөлімге байланыстырмас бұрын нақты жолды алдын ала анықтап алуды ұсынамыз.",
    l_Information_block_banner: "Қолдану алдыңда ұсынылатын ақпарат",
    l_Required_field: "Міндетті өріс",
    l_Change_history: "Өзгерістер тарихы",
    l_Updated_by: "Кім өзгертті",
    l_History_create: "Жасалды",
    l_History_update: "Өзгертілді",
    l_History_enable: "Қосылды",
    l_History_disable: "Өшірілді",
    l_History_delete: "Жойылды",
    l_Home_page: "Басты бет",
    l_Promocode_actions: "Промокод акциялары",
    l_Export_to_excel: "Excel",
    l_Create_promo_action: "Акция құру",
    l_Search_by_promocode: "Промокод бойынша іздеу",
    l_Enter_promocode: "Промокодты енгізіңіз",
    l_Promo_action_name: "Акция атауы",
    l_Bonus_amount: "Бонус сомасы",
    l_Period_range: "Мерзімі",
    l_Used_count: "Қолданылуы",
    l_Promo_finished: "Аяқталған",
    l_Promo_stopped: "Тоқтатылған",
    l_Total_records: "Барлығы {count} жазба",
    l_Per_page: "бет",
    l_Country_label: "Ел",
    l_Url_example: "Егер қосымша бөлімін ашу қажет болса jana_webview:https://... енгізіңіз",
    l_Please_enter_full_name: "Толық аты-жөні енгізіңіз",
    l_Please_enter_email: "Пошта енгізіңіз",
    l_Please_enter_valid_email: "Дұрыс пошта енгізіңіз",
    l_Archive: "Архив",
    l_Archived_promo_actions: "Архивтелген промокод акциялары",
    l_Back_to_promo_actions: "Промокод акцияларына оралу",
    l_Archived_date: "Архивтелген күні",
    l_Make_copy: "Көшірмесін жасау",
    l_Restore: "Қайтару",
    l_Export_to_excel_v2: "Excel-ге жүктеу",
    l_Choose: "Таңдау",
    l_Choose_country: "Елді таңдаңыз",
    l_General_section: "Жалпы",
    l_Enter_promo_name: "Акция атауын енгізіңіз",
    l_Enter_bonus: "Бонус сомасын енгізіңіз",
    l_Promocode_conditions: "Есептеу шарттары",
    l_Immediately_after_code: "Енгізгеннен соң",
    l_After_order: "Тапсырыстан соң",
    l_Order_type: "Тапсырыс түрі",
    l_Order_status_paid: "Төленген",
    l_Order_status_delivered: "Жеткізілген",
    l_Which_order_counts: "Тапсырысты ескеру",
    l_First_order: "Алғашқы тапсырыс",
    l_Any_order: "Кез келген тапсырыс",
    l_Select_placeholder: "Мәнді таңдаңыз",
    l_Period_and_limits: "Қолданылу мерзімі және лимиттер",
    l_Start_date: "Басталуы",
    l_End_date: "Аяқталуы",
    l_Select_date: "Күнді таңдаңыз",
    l_Unlimited: "Мерзімсіз",
    l_Bonus_lifetime_days: "Жарамдылық мерзімі",
    l_Enter_days_placeholder: "Күн санын енгізіңіз",
    l_Participant_limit: "Қатысушылар лимиті",
    l_Enter_limit: "Қатысушылар лимитін енгізіңіз",
    l_Max_bonus_share: "Бонуспен төлеудің максималды үлесі",
    l_Enter_percent: "Мәнді енгізіңіз",
    l_Percent_of_order_amount: "тапсырыс сомасынан",
    l_Notification_texts: "Хабарлама мәтіндері",
    l_Enter_notification_text: "Хабарлама мәтінін енгізіңіз",
    l_Draft_not_active: "Жоба • белсенді емес",
    l_Save_changes: "Өзгерістерді сақтау",
    l_Launch_action: "Акцияны іске қосу",
    l_Changes_saved: "Өзгерістер сақталды",
    l_Promo_action_launched: "Акция іске қосылды",
    l_Duplicate_action: "Көшірмесін жасау",
    l_Edit_info: "Ақпаратты өңдеу",
    l_Pause_action: "Белсенділікпен тоқтату",
    l_Stop_early: "Мерзімінен бұрын тоқтату",
    l_Send_to_archive: "Архивке жіберу",
    l_Action_period: "Акция кезеңі",
    l_Bonus_condition: "Бонус шарты",
    l_Calculated_bonus: "Есептелген бонус",
    l_Bonus_usage_rate: "Бонусты пайдалану деңгейі",
    l_Active_period_left: "Белсенді кезең",
    l_Avg_daily_spend: "Орташа күндік жұмсалым",
    l_Day_short: "күн",
    l_Awaiting_condition: "Шартты орындауды күтуде",
    l_Conversion_funnel: "Конверсия воронкасы",
    l_Funnel_code_entered: "Код енгізді",
    l_Funnel_condition_fulfilled: "Шарт орындалды",
    l_Funnel_bonus_used: "Бонусты пайдаланды",
    l_Funnel_bonus_burned: "Бонус пайдаланылмай жанып кетті",
    l_Bonus_status: "Бонус күйі",
    l_Bonus_status_unused: "Пайдаланылмаған",
    l_Bonus_status_spent: "Жұмсалған",
    l_Bonus_status_burned: "Жанып кеткен",
    l_Bonus_status_returned: "Қайтарылған",
    l_Usage_list: "Қолданулар тізімі",
    l_Usage_pending: "Күтуде",
    l_Usage_completed: "Орындалды",
    l_Usage_returned: "Кері қайтарылды",
    l_Search_by_phone: "Телефон бойынша іздеу",
    l_Filters: "Фильтрлер",
    l_Client_phone: "Клиент (телефон)",
    l_Used_at: "Қолданылған уақыты",
    l_Calculated: "Есептелді",
    l_Expire_date: "Жану күні",
    l_Order_number: "Тапсырыс №",
    l_Active_tab: "Белсенді",
    l_Archive_tab: "Архив",
    l_Search_promocode_or_name: "Промокодты / акция атауын енгізіңіз",
    l_Was_sent_to_archive: "Промокод акциясы архивке жіберілді",
    l_New_promo_code: "Жаңа промокод",
    l_Edit_promo_code: "Промокодты өңдеу",
    l_Duplicate_promo_code: "Промокодтың көшірмесін жасау",
    l_Restart_promo_code: "Промокодты қайта қосу",
    l_Usage_conditions: "Пайдалану шарттары",
    l_Balance_carries_over: "Қалдық шотқа түседі",
    l_Balance_burns_out: "Қалдық күйіп кетеді",
    l_Order_conditions: "Тапсырыс шарттары",
    l_No_limit: "Шектеусіз",
    l_No_end_date: "Аяқталу күні жоқ",
    l_Order_status_paid_desc: "бонус төлемнен кейін",
    l_Order_status_delivered_desc: "бонус жеткізуден кейін",
    l_First_order_desc: "тек алғашқы",
    l_Any_order_desc: "кез келген",
    l_Applied_count: "Қолданылуы",
    l_Ordered_count: "Тапсырыс берді",
    l_Accrued: "Есептелді",
    l_Kg_short: "кг",
    l_Condition_fulfilled: "шарт орындалды",
    l_By_orders_with_promo: "промокодтық тапсырыстар",
    l_Applied_to_order: "қолданылуы -> тапсырыс",
    l_Bonus_sum: "бонустар сомасы",
    l_Spent: "Жұмсалды",
    l_Written_off_in_orders: "тапсырыстарда шегерілді",
    l_By_lifetime: "жарамдылық мерзімі бойынша",
    l_Returned: "Қайтарып алынды",
    l_Order_cancellations: "тапсырыстардынан бас тарту",
    l_Actions: "Әрекеттер",
    l_Funnel_accrued: "Есептелді",
    l_Funnel_bonus_spent: "Бонусты жұмсады",
    l_Funnel_burned_without_spend: "Жұмсалмай күйіп кетті",
    l_Applied_at: "Қолданылды",
    l_Applied_date: "Қолданылған күні",
    l_Date_expired: "Мерзімі өтті",
    l_Unlimited_v2: "Лимитсіз",
    l_Condition: "Шарт",
    l_Accrual_after_warehouse: "Жеткізілгеннен кейін",
    l_Accrual_after_payment: "Төлемнен кейін",
    l_Accrual_immediate: "Бірден түседі",
    l_Restart: "Қайта қосу",
    l_Restore_from_archive: "Архивтен шығару",
    l_Standard_desc: "Қалғаны шотқа",
    l_Single_use_remainder_desc: "Қалғаны күйіп кетеді",
    l_Choose_status: "Күй таңдаңыз",
    l_Launch_now: "Қосу",
    l_Duplicate: "Көшіру",
    l_Action_not_configured: "Әрекет жасалмады",
    l_Stopped: "Тоқтатылды",
    l_Resume_v2: "Қайта қосу",
    l_Resumed: "Қайта қосылды",
    l_Restored_from_archive: "Архивтен шығарылды",
    l_Stop: "Тоқтату",
    l_Promo_details: "Промокод ақпараты",
    l_Days_short: "күн",
    l_Remote_config_custom_order: "Тапсырыс құру",
    l_Select_country: "Мемлекетті таңдаңыз",
    l_All_countries_added: "Барлық мемлекеттер қосылды",
    l_Feature_flags: "Функция флагтары",
    l_Control_groups: "Пайдаланушы топтары",
    l_Show_to_all: "Барлығына көрінеді",
    l_Show_to_group: "Группаға көрінеді",
    l_Show_by_conditions: "Шарттар бойынша көрінеді",
    l_Countries: "Мемлекеттер",
    l_Add_country: "Мемлекет қосу",
    l_Station_code_prefixes: "Бөлімше префикстері",
    l_Enter_station_code_prefixes: "Префикстерді енгізіңіз, мысалы JP02",
    l_Station_code_prefixes_hint: "Клиенттің бөлімшесінің коды осы префикстердің бірінен басталуы керек",
    l_Conditions: "Шарттар",
    l_Group_or_users_required: "Топты таңдаңыз немесе кемінде бір клиентті енгізіңіз",
    l_Country_or_station_prefix_required: "Мемлекетті таңдаңыз немесе кемінде бір бөлімше префиксін енгізіңіз",
    l_Code: "Код",
    l_Enter_title: "Тақырып енгізіңіз",
    l_Enter_code: "Код енгізіңіз",
    l_Select_group: "Группа таңдаңыз",
    l_Users_list: "Қолданушылар тізімі",
    l_Enter_users: "Қолданушыларды енгізіңіз",
    l_Users_count: "Қолданушылар саны",
    l_Badges: "Белгілер",
    l_Not_set: "Таңдалмады",
    l_Text_color: "Текст түсі",
    l_Background_color: "Background түсі",
    l_Approximate: "Жобамен",
    l_Logo: "Логотип",
    l_Enter_marketplace: "Маркетплейс енгізіңіз",
    l_Chapters: "Бөлімдер",
    l_No_chapters: "Бөлімдер жоқ",
    l_Add_chapter: "Бөлім қосу",
    l_Chapter_name: "Бөлім атауы",
    l_Required: "Міндетті өріс",
    l_Start_seconds: "Басталу (секунд)",
    l_Duplicate_chapter_start_time: "Екі бөлім бір секундта бастала алмайды",
    l_Video_timeline: "Бейне TimeLine",
    l_Fill_all_notification_texts: "Барлық хабарлама мәтіндерін толтырыңыз",
    l_Field_required: "Бұл өріс міндетті",
    l_Restart_action: "Қайта қосу",
    l_Promo_action_restarted: "Промокод қайта қосылды",
    l_Fill_required_fields: "Міндетті өрістерді толтырыңыз",
    l_Use_second_page_to_add_promocode: "Системді промокодты қосу үшін келесі (v2) бетті пайдаланыңыз",
}
